import {STORAGE_TYPE} from "Core/storage/const";
import {app_id} from "Config/app";

/**
 * Storage type used to save a user's access-control list (ACL)
 * @type {string}
 */
export const acl_storage_type = STORAGE_TYPE.LOCAL;

/**
 * Name of the variable used for storing the user's access-control list (ACL)
 * @type {string}
 */
export const acl_storage_var = `${app_id}_acl`;

/**
 * Mode for checking permissions
 * @description When checking if user has permissions to access a resource or execute some action there can be more
 * than one type of permission checking based on the way permissions are defined in the system.
 * @type {'AND'|'OR'}
 * 	- 'AND': Check is performed so that all permissions must be met.
 * 	- 'OR': Check is performed so that at least one permission must be met.
 */
export const acl_check_mode = 'OR';

/**
 * Super permission that has access to all resources and can execute any command
 * @note If empty or null no super permission will exist in the app.
 * @type {any}
 */
export const acl_super_permission = 'ALL';

/**
 * Superuser type that has access to all resources and can execute any command
 * @note If empty or null no super role will exist in the app.
 * @type {any}
 */
export const acl_super_user_type = 'SUPER_ADMIN';

/**
 * Name of the field in security init response that contains the current user's ID
 * @type {string}
 */
export const acl_user_id_field_name = 'userAccountId';
/**
 * Name of the field in security init response that contains the current user's user type
 * @type {string}
 */
export const acl_user_type_field_name = 'userAccountType';
/**
 * Name of the field in security init response that contains the current user's permissions' array.
 * @type {string}
 */
export const acl_permissions_field_name = 'permissionCodes';
/**
 * Name of the field in security init response that contains the current user's guest flag.
 * @type {string}
 */
export const acl_guest_flag_field_name = 'userIsGuest';
/**
 * Name of the variable used for storing a projects-specific access-control list (ACL)
 * @type {string}
 */
export const acl_project_permissions_field_name = 'projectPermissionsMap';
/**
 * Array of field names that are used in ACL module.
 * @description These fields are used to extract user's ACL data from the user-related responses, like 'securityInit',
 * from the server.
 * @note Should be defined directly above.
 * @type {string[]}
 */
export const acl_field_names = [
	acl_user_type_field_name,
	acl_permissions_field_name,
	acl_guest_flag_field_name,
	acl_project_permissions_field_name
];